import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Table, TableHeader, TableRow, TableHeaderColumn, TableBody, TableRowColumn, RaisedButton,
  Card, CardText, CardHeader, Drawer, Dialog, FlatButton, IconButton, Paper, TextField,
} from "material-ui";
import { red100 } from "material-ui/styles/colors";
import Editar from "material-ui/svg-icons/image/edit";
import Eliminar from "material-ui/svg-icons/action/delete";
import Getapp from "material-ui/svg-icons/action/get-app";
import Add from "./../../../images/nuevo.png";
import Mod from "./../../../images/modificar.png";
import Del from "./../../../images/eliminar.png";
import {
  OpenQuitarPrestacionSolicitud, QuitarPrestacionSolicitudSeleccionada, OpenModalEliminarBorrador,
  LimpiarSolicitud, getBorrador, pushDetalleSolicitud, GuardarSolicitudParametrizada,
  updateSolicitudsync, UpdateIdSolicitud, UpdateStatusBorrador, deletePrestacionesBorrador, OpenSolicitudEnviada,
  sendToHomologador,
  PrestacionesToHomologador,
  IdSolicitudForHomologador,
  IdSolicitudHom,
  nuevaSolicitud
} from "./actions";
import { isNull } from "util";
import store from "../../../config/store";

import {
  deleteBorrador, ValidarPrestacionesSolicitudEnCurso,
} from "../FiltroBusqueda/actions";

import SolicitudEditarCreacion from "../SolicitudEditarCreacion/view";
import { OpenSolicitudEditarCreacion } from "../SolicitudEditarCreacion/actions";
import SolicitudEditarEliminacion from "../SolicitudEditarEliminacion/view";
import { OpenSolicitudEditarEliminacion } from "../SolicitudEditarEliminacion/actions";
import SolicitudEditarModificacion from "../SolicitudEditarModificacion/view";
import { OpenSolicitudEditarModificacion } from "../SolicitudEditarModificacion/actions";
import { ErrorSnacktOpen } from "../../ErrorSnack/actions";
import styles from "../../styles/styles";
import TablePaginationCustom from "../../TablePagination/view";
import { DialogGeneric } from "../../Global/actions";
import { PermiteReplicarSolicitud } from "../ReplicarSolicitud/actions";
import ReplicarSolicitud from "../ReplicarSolicitud/view";
import urlHelper from "../../../helpers/urlHelper";

class GrillaSolicitud extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalEnviarSolicitud: false,
      observaciones: "",
    };
  }

  componentWillMount() { }

  ModalSolicitudReajuste = () => {
    urlHelper.RedirectTo("SolicitudesRealizadas");
  }

  CloseQuitarPrestacionSolicitud = () => {
    this.props.dispatch(OpenQuitarPrestacionSolicitud(false, null));
  }

  OpenQuitarPrestacionSolicitud = (guidRow) => {
    this.props.dispatch(OpenQuitarPrestacionSolicitud(true, guidRow));
  }

  QuitarPrestacionSolicitudSeleccionada = () => {
    this.props.CambiosSinGuardar(true);
    this.props.dispatch(QuitarPrestacionSolicitudSeleccionada());
    this.props.dispatch(OpenQuitarPrestacionSolicitud(false, null));
  }

  CloseModalEliminarBorrador = () => {
    this.props.dispatch(OpenModalEliminarBorrador(false));
  }

  mostrarModalEnviarSolicitud = () => {
    this.setState({ modalEnviarSolicitud: !this.state.modalEnviarSolicitud });
    this.props.dispatch(nuevaSolicitud(null));
  }

  modificarObservaciones = (event) => {
    this.setState({ observaciones: event.target.value });
  }

  openModalSolicitudEnviada = () => {
    this.props.dispatch(PermiteReplicarSolicitud());
    this.props.dispatch(OpenSolicitudEnviada(true));
  }

  OpenModalEliminarBorrador = () => {
    this.props.dispatch(OpenModalEliminarBorrador(true));
  }

  validarSolicitud(option) {
    switch (option) {
      case 1: // Enviar Solicitud
        this.mostrarModalEnviarSolicitud();
        if (!this.props.prestacionesSolicitud || this.props.prestacionesSolicitud.length === 0) {
          this.props.dispatch(ErrorSnacktOpen("Solicitud No Enviada | Enviar Solicitud"));
        } else if (this.props.ENV.ENVIAR_SOLICITUD_CUANDO_EXISTE_EN_CURSO) {
          this.guardarSolicitud();
        } else {
          this.props.dispatch(ValidarPrestacionesSolicitudEnCurso(null, this.guardarSolicitud));
        }
        break;
      case 2: // Eliminar Borrador
        if (!this.props.prestacionesSolicitud || this.props.prestacionesSolicitud.length === 0) {
          this.props.dispatch(ErrorSnacktOpen("Solicitud No Enviada | Eliminar Borrador"));
        } else {
          this.OpenModalEliminarBorrador();
        }
        break;
      case 3: // Guardar Borrador
        if (!this.props.prestacionesSolicitud || this.props.prestacionesSolicitud.length === 0) {
          this.props.dispatch(ErrorSnacktOpen("Solicitud No Enviada | Guardar Borrador"));
        } else {
          this.GuardarBorrador();
        }
        break;
      default:
    }
  }

  guardarSolicitud = async () => {
    const { REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA: fechaVigenciaPrestador } = this.props.ENV;
    let validaFechaVigencia = true;
    let validaFechaFinVigencia = true;
    const dateMin = new Date(Date.now());
    dateMin.setDate(dateMin.getDate() + +fechaVigenciaPrestador);
    dateMin.setHours(0, 0, 0, 0);
    this.props.prestacionesSolicitud.forEach((prestacion) => {
      if (prestacion.INICIO_VIG != null) {
        const InicioVig = new Date(prestacion.INICIO_VIG);
        InicioVig.setHours(0, 0, 0, 0);
        if (InicioVig < dateMin && prestacion.COD_OPERACION !== "2") {
          validaFechaVigencia = false;
        }
      }
      if (prestacion.FECHA_FIN_VIG != null) {
        const FinVig = new Date(prestacion.FECHA_FIN_VIG);
        FinVig.setHours(0, 0, 0, 0);
        if (FinVig < dateMin && prestacion.COD_OPERACION === "2") {
          validaFechaFinVigencia = false;
        }
      }
    });
    if (!validaFechaVigencia) {
      this.props.dispatch(DialogGeneric(
        true,
        "Existen errores en las fecha de vigencia. Favor validar"
      ));
      return;
    }
    if (!validaFechaFinVigencia) {
      this.props.dispatch(DialogGeneric(
        true,
        "Existen errores en las fecha de fin vigencia. Favor validar"
      ));
      return;
    }

    const globalState = store.getState().global;

    let listaUsuarios = "";
    let numNuevas = 0;
    let IdEstadoProceso = 0;
    let IdEstadoSolicitudWF = 0;
    const IdEstadoSolicitud = 8; // --8: SolicitudEnviada
    const IdTipoModificacionSolicitud = 11; // --11: ActualizarArancel
    //const prestacionesToHomologador = [];
    if (this.props.prestacionesSolicitud) {
      numNuevas = this.props.prestacionesSolicitud.filter((p) => p.COD_OPERACION === "1").length;

      if (numNuevas > 0) {
        this.props.dispatch(IdSolicitudHom(0));
        IdEstadoProceso = 15;
        IdEstadoSolicitudWF = 36;
        listaUsuarios = globalState.listaUsuariosContraloria;
      } else {
        IdEstadoProceso = 14;
        IdEstadoSolicitudWF = 38;
        listaUsuarios = globalState.listaUsuariosConvenio;
      }
    }

    // update to test azure

    //console.log('this.props.idSolicitud', this.props.idSolicitud);

    if (this.props.idSolicitud === null) {
      await this.props.dispatch(GuardarSolicitudParametrizada(
        this.props.rutPrestador, this.props.rutInstitucion, this.props.isapre,
        IdEstadoSolicitud, IdTipoModificacionSolicitud, IdEstadoProceso, IdEstadoSolicitudWF,
        this.state.observaciones, listaUsuarios, async IdSolicitud => {
          await this.props.dispatch(IdSolicitudForHomologador(IdSolicitud));
          this.props.prestacionesSolicitud.forEach((prestacion) => {
            let FinVig = null;
            let FechaFinVigencia = null;
            let InicioVig = null;
            let newInicioVig = null;
            let InicioVigPrev = null;
            let newInicioVigPrev = null;
            const CodPertenenciaFonasa = prestacion.PERTENENCIA_FONASA || 0;
            const codigoFonasa = prestacion.CODIGO_FONASA;
            const guarismo = prestacion.GUARISMO;
            const tipoAccionPrestacion = parseInt(prestacion.COD_OPERACION, 0) || 0;
            const arancel = prestacion.RUTARANCEL || 0;
            const valorAnterior = prestacion.VALOR || 0;
            const valorPosterior = prestacion.VALOR || 0;
            const grupoPrestacionPrestador = prestacion.TIPO_PRESTACION || 0;

            const prestacionDetalle = {
              IdSolicitud,
              CentroAtencionSecuencia: prestacion.SECUENCIA,
              Arancel: arancel,
              CodigoFonasa: codigoFonasa,
              Guarismo: guarismo,
              IdPrestacionIsapre: prestacion.IDPRESTACION,
              ItemImed: prestacion.ITEM_IMED,
              IdTipoAccionPrestacion: tipoAccionPrestacion,
              PertenenciaFonasa: CodPertenenciaFonasa,
              TipoAtencion: prestacion.TIPO_ATENCION,
              GlosaPrestacionPrestador: prestacion.GLOSA_CODPRESTADOR,
              GlosaGrupoPrestacionPrestador: prestacion.GLOSA_GRUPO_PRESTACION,

              CodigoPrestacionIsapre: null,
              CodigoPrestacionPrestador: prestacion.COD_PRESTADOR,
              CodigoProfesionalIsapre: null,
              CodigoProfesionalPrestador: prestacion.PROF_CCOD,
              FechaInicioVigenciaAnterior: null,
              FechaInicioVigenciaPosterior: null,
              FechaTerminoVigenciaAnterior: null,
              FechaTerminoVigenciaPosterior: null,
              GrupoPrestacionIsapre: null,
              GrupoPrestacionPrestador: grupoPrestacionPrestador,
              UnidadAnterior: null,
              UnidadPosterior: prestacion.UNIDAD,
              ValorAnterior: null,
              ValorPosterior: valorPosterior,
            };
            if (prestacion.INICIO_VIG) {
              InicioVig = new Date(prestacion.INICIO_VIG);
              newInicioVig = `${InicioVig.getDate()}/${InicioVig.getMonth() + 1}/${InicioVig.getFullYear()} 00:00:00`;
            }
            if (prestacion.INICIO_VIG_PREV) {
              InicioVigPrev = new Date(prestacion.INICIO_VIG_PREV);
              newInicioVigPrev = `${InicioVigPrev.getDate()}/${InicioVigPrev.getMonth() + 1}/${InicioVigPrev.getFullYear()} 00:00:00`;
            }
            if (prestacion.FECHA_FIN_VIG) {
              FinVig = new Date(prestacion.FECHA_FIN_VIG);
              FechaFinVigencia = `${FinVig.getDate()}/${FinVig.getMonth() + 1}/${FinVig.getFullYear()} 00:00:00`;
            }

            // Agregar
            if (tipoAccionPrestacion === 1) {
              prestacionDetalle.FechaInicioVigenciaPosterior = newInicioVig;
            }
            // Modificar
            if (tipoAccionPrestacion === 3) {
              prestacionDetalle.FechaInicioVigenciaAnterior = newInicioVigPrev;
              prestacionDetalle.FechaInicioVigenciaPosterior = newInicioVig;
              prestacionDetalle.FechaTerminoVigenciaAnterior = null;
              prestacionDetalle.FechaTerminoVigenciaPosterior = null;
              prestacionDetalle.UnidadAnterior = prestacion.UNIDAD_ANT;
              prestacionDetalle.ValorAnterior = prestacion.VALOR_ANT;
              prestacionDetalle.CodigoPrestacionIsapre = prestacion.COD_ISAPRE;
              prestacionDetalle.CodigoProfesionalIsapre = prestacion.PROF_CCOD;
              prestacionDetalle.GrupoPrestacionIsapre = grupoPrestacionPrestador;
            }
            // Eliminar
            if (tipoAccionPrestacion === 2) {
              prestacionDetalle.FechaInicioVigenciaAnterior = newInicioVigPrev;
              prestacionDetalle.FechaInicioVigenciaPosterior = null;
              prestacionDetalle.FechaTerminoVigenciaAnterior = null;
              prestacionDetalle.FechaTerminoVigenciaPosterior = FechaFinVigencia;
              prestacionDetalle.UnidadAnterior = prestacion.UNIDAD;
              prestacionDetalle.ValorAnterior = valorAnterior;
              prestacionDetalle.CodigoPrestacionIsapre = prestacion.COD_ISAPRE;
              prestacionDetalle.CodigoProfesionalIsapre = prestacion.PROF_CCOD;
              prestacionDetalle.GrupoPrestacionIsapre = grupoPrestacionPrestador;
            }
            this.props.dispatch(pushDetalleSolicitud(prestacionDetalle));
          });

          this.props.dispatch(PrestacionesToHomologador(this.props.prestacionesSolicitud));

          // Implementar servicio de homologador
          if (numNuevas > 0) {
            await this.props.dispatch(sendToHomologador(this.props.rutPrestador));
          }
          else {
            this.openModalSolicitudEnviada();
            this.props.dispatch(ErrorSnacktOpen("Solicitud Enviada"));
          }

        }
      ));

      //console.log('this.props.prestacionesSolicitud', this.props.prestacionesSolicitud)

      this.props.dispatch(UpdateStatusBorrador(true));

      // this.props.dispatch(updateSolicitud(this.props.idSolicitud, 8)); // 8= solicitud enviada
    } else {
      await updateSolicitudsync(
        this.props.idSolicitud, IdEstadoSolicitud, listaUsuarios,
        IdTipoModificacionSolicitud, IdEstadoProceso, IdEstadoSolicitudWF
      );

      this.props.prestacionesSolicitud.forEach((prestacion) => {
        let FinVig = null;
        let FechaFinVigencia = null;
        let InicioVig = null;
        let newInicioVig = null;
        let InicioVigPrev = null;
        let newInicioVigPrev = null;
        const CodPertenenciaFonasa = prestacion.PERTENENCIA_FONASA || 0;
        const codigoFonasa = prestacion.CODIGO_FONASA;
        const guarismo = prestacion.GUARISMO;
        const tipoAccionPrestacion = parseInt(prestacion.COD_OPERACION, 0) || 0;
        const arancel = prestacion.RUTARANCEL || 0;
        const valorAnterior = prestacion.VALOR || 0;
        const valorPosterior = prestacion.VALOR || 0;
        const grupoPrestacionPrestador = prestacion.TIPO_PRESTACION || 0;

        const prestacionDetalle = {
          IdSolicitud: this.props.idSolicitud,
          CentroAtencionSecuencia: prestacion.SECUENCIA,
          Arancel: arancel,
          CodigoFonasa: codigoFonasa,
          Guarismo: guarismo,
          IdPrestacionIsapre: prestacion.IDPRESTACION,
          ItemImed: prestacion.ITEM_IMED,
          IdTipoAccionPrestacion: tipoAccionPrestacion,
          PertenenciaFonasa: CodPertenenciaFonasa,
          TipoAtencion: prestacion.TIPO_ATENCION,
          GlosaPrestacionPrestador: prestacion.GLOSA_CODPRESTADOR,
          GlosaGrupoPrestacionPrestador: prestacion.GLOSA_GRUPO_PRESTACION,

          CodigoPrestacionIsapre: null,
          CodigoPrestacionPrestador: prestacion.COD_PRESTADOR,
          CodigoProfesionalIsapre: null,
          CodigoProfesionalPrestador: prestacion.PROF_CCOD,
          FechaInicioVigenciaAnterior: null,
          FechaInicioVigenciaPosterior: null,
          FechaTerminoVigenciaAnterior: null,
          FechaTerminoVigenciaPosterior: null,
          GrupoPrestacionIsapre: null,
          GrupoPrestacionPrestador: grupoPrestacionPrestador,
          UnidadAnterior: null,
          UnidadPosterior: prestacion.UNIDAD,
          ValorAnterior: null,
          ValorPosterior: valorPosterior,
        };
        if (prestacion.INICIO_VIG) {
          InicioVig = new Date(prestacion.INICIO_VIG);
          newInicioVig = `${InicioVig.getDate()}/${InicioVig.getMonth() + 1}/${InicioVig.getFullYear()} 00:00:00`;
        }
        if (prestacion.INICIO_VIG_PREV) {
          InicioVigPrev = new Date(prestacion.INICIO_VIG_PREV);
          newInicioVigPrev = `${InicioVigPrev.getDate()}/${InicioVigPrev.getMonth() + 1}/${InicioVigPrev.getFullYear()} 00:00:00`;
        }
        if (prestacion.FECHA_FIN_VIG) {
          FinVig = new Date(prestacion.FECHA_FIN_VIG);
          FechaFinVigencia = `${FinVig.getDate()}/${FinVig.getMonth() + 1}/${FinVig.getFullYear()} 00:00:00`;
        }

        // Agregar
        if (tipoAccionPrestacion === 1) {
          prestacionDetalle.FechaInicioVigenciaPosterior = newInicioVig;
        }
        // Modificar
        if (tipoAccionPrestacion === 3) {
          prestacionDetalle.FechaInicioVigenciaAnterior = newInicioVigPrev;
          prestacionDetalle.FechaInicioVigenciaPosterior = newInicioVig;
          prestacionDetalle.FechaTerminoVigenciaAnterior = null;
          prestacionDetalle.FechaTerminoVigenciaPosterior = null;
          prestacionDetalle.UnidadAnterior = prestacion.UNIDAD_ANT;
          prestacionDetalle.ValorAnterior = prestacion.VALOR_ANT;
          prestacionDetalle.CodigoPrestacionIsapre = prestacion.COD_ISAPRE;
          prestacionDetalle.CodigoProfesionalIsapre = prestacion.PROF_CCOD;
          prestacionDetalle.GrupoPrestacionIsapre = grupoPrestacionPrestador;
        }
        // Eliminar
        if (tipoAccionPrestacion === 2) {
          prestacionDetalle.FechaInicioVigenciaAnterior = newInicioVigPrev;
          prestacionDetalle.FechaInicioVigenciaPosterior = null;
          prestacionDetalle.FechaTerminoVigenciaAnterior = null;
          prestacionDetalle.FechaTerminoVigenciaPosterior = FechaFinVigencia;
          prestacionDetalle.UnidadAnterior = prestacion.UNIDAD;
          prestacionDetalle.ValorAnterior = valorAnterior;
          prestacionDetalle.CodigoPrestacionIsapre = prestacion.COD_ISAPRE;
          prestacionDetalle.CodigoProfesionalIsapre = prestacion.PROF_CCOD;
          prestacionDetalle.GrupoPrestacionIsapre = grupoPrestacionPrestador;
        }
        this.props.dispatch(pushDetalleSolicitud(prestacionDetalle));
      });

      this.props.dispatch(UpdateIdSolicitud(this.props.idSolicitud, false));

      this.openModalSolicitudEnviada();
      this.props.dispatch(ErrorSnacktOpen("Solicitud Enviada"));
    }

    // this.props.dispatch(getBorrador(this.props.rutPrestador, this.props.rutInstitucion, this.props.isapre));
    // this.props.dispatch(updateSolicitud(this.props.idSolicitud, 8)); // 8= solicitud enviada
    // this.openModalSolicitudEnviada();
    // this.props.dispatch(ErrorSnacktOpen("Solicitud Enviada"));
  }

  GuardarBorrador = () => {
    const { REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA: fechaVigenciaPrestador } = this.props.ENV;

    let validaFechaVigencia = true;
    let validaFechaFinVigencia = true;
    const dateMin = new Date(Date.now());
    dateMin.setDate(dateMin.getDate() + fechaVigenciaPrestador);
    dateMin.setHours(0, 0, 0, 0);
    for (let i = 0; i < this.props.prestacionesSolicitud.length; i += 1) {
      if (this.props.prestacionesSolicitud[i].INICIO_VIG != null) {
        const InicioVig = new Date(this.props.prestacionesSolicitud[i].INICIO_VIG);
        InicioVig.setHours(0, 0, 0, 0);
        if (InicioVig < dateMin && this.props.prestacionesSolicitud[i].COD_OPERACION !== "2") {
          validaFechaVigencia = false;
        }
      }
      if (this.props.prestacionesSolicitud[i].FECHA_FIN_VIG != null) {
        const FinVig = new Date(this.props.prestacionesSolicitud[i].FECHA_FIN_VIG);
        FinVig.setHours(0, 0, 0, 0);
        if (FinVig < dateMin && this.props.prestacionesSolicitud[i].COD_OPERACION === "2") {
          validaFechaFinVigencia = false;
        }
      }
    }

    if (!validaFechaVigencia) {
      this.props.dispatch(DialogGeneric(
        true,
        "Existen errores en las fecha de vigencia. Favor validar"
      ));
      return;
    }
    if (!validaFechaFinVigencia) {
      this.props.dispatch(DialogGeneric(
        true,
        "Existen errores en las fecha de fin vigencia. Favor validar"
      ));
      return;
    }

    if (this.props.idSolicitud == null) {
      this.props.dispatch(getBorrador(this.props.rutPrestador, this.props.rutInstitucion, this.props.isapre, saveDetails));
      const props = {
        ...this.props,
      };

      function saveDetails(IdSolicitud) {
        const prestsToSend = [];

        props.prestacionesSolicitud.forEach((prestacion) => {
          let finVigencia = null;
          let InicioVig = null;
          let newInicioVig = null;

          if (!isNull(prestacion.FECHA_FIN_VIG) && typeof prestacion.FECHA_FIN_VIG !== "undefined") {
            finVigencia = new Date(prestacion.FECHA_FIN_VIG);
            finVigencia = `${finVigencia.getDate()}/${finVigencia.getMonth() + 1}/${finVigencia.getFullYear()} 00:00:00`;
          }

          if (!isNull(prestacion.INICIO_VIG) && typeof prestacion.INICIO_VIG !== "undefined") {
            InicioVig = new Date(prestacion.INICIO_VIG);
            newInicioVig = `${InicioVig.getDate()}/${InicioVig.getMonth() + 1}/${InicioVig.getFullYear()} 00:00:00`;
          }

          if (typeof prestacion.INICIO_VIG === "undefined" && typeof prestacion.INICIO_VIG_PREV !== "undefined" && prestacion.INICIO_VIG_PREV != null) {
            InicioVig = new Date(prestacion.INICIO_VIG_PREV);
            newInicioVig = `${InicioVig.getDate()}/${InicioVig.getMonth() + 1}/${InicioVig.getFullYear()} 00:00:00`;
          }

          const CodPertenenciaFonasa = prestacion.PERTENENCIA_FONASA || 0;

          const prestacionDetalle = {
            CentroAtencionSecuencia: prestacion.SECUENCIA,
            CodigoFonasa: prestacion.CODIGO_FONASA,
            CodigoPrestacionIsapre: prestacion.COD_ISAPRE,
            CodigoPrestacionPrestador: prestacion.COD_PRESTADOR,
            CodigoProfesionalIsapre: prestacion.PROF_CCOD,
            CodigoProfesionalPrestador: prestacion.PROF_CCOD,
            FechaInicioVigenciaAnterior: newInicioVig,
            FechaInicioVigenciaPosterior: newInicioVig,
            FechaTerminoVigenciaAnterior: finVigencia,
            FechaTerminoVigenciaPosterior: finVigencia,
            GlosaGrupoPrestacionPrestador: prestacion.GLOSA_GRUPOPRESTADOR,
            GlosaPrestacionPrestador: prestacion.GLOSA_CODPRESTADOR,
            GrupoPrestacionIsapre: 0,
            GrupoPrestacionPrestador: 0,
            Guarismo: prestacion.GUARISMO,
            IdPrestacionIsapre: prestacion.IDPRESTACION,
            IdSolicitud,
            IdTipoAccionPrestacion: prestacion.COD_OPERACION,
            ItemImed: prestacion.ITEM_IMED,
            PertenenciaFonasa: CodPertenenciaFonasa,
            Arancel: prestacion.RUTARANCEL,
            TipoAtencion: prestacion.TIPO_ATENCION,
            UnidadAnterior: prestacion.UNIDAD_ANT,
            UnidadPosterior: prestacion.UNIDAD,
            ValorAnterior: prestacion.VALOR_ANT,
            ValorPosterior: prestacion.VALOR,
          };
          prestsToSend.push(prestacionDetalle);
        });

        props.dispatch(pushDetalleSolicitud({ prestsToSend, saveBorrador: true }));
      }
    } else {
      // this.props.dispatch(deletePrestacionesBorrador(this.props.idSolicitud));
      const prestsToSend = [];

      this.props.prestacionesSolicitud.forEach((prestacion) => {
        let finVigencia = null;
        let InicioVig = null;
        let newInicioVig = null;

        if (!isNull(prestacion.FECHA_FIN_VIG) && typeof prestacion.FECHA_FIN_VIG != "undefined") {
          finVigencia = new Date(prestacion.FECHA_FIN_VIG);
          finVigencia = `${finVigencia.getDate()}/${finVigencia.getMonth() + 1}/${finVigencia.getFullYear()} 00:00:00`;
        }

        if (!isNull(prestacion.INICIO_VIG) && typeof prestacion.INICIO_VIG !== "undefined") {
          InicioVig = new Date(prestacion.INICIO_VIG);
          newInicioVig = `${InicioVig.getDate()}/${InicioVig.getMonth() + 1}/${InicioVig.getFullYear()} 00:00:00`;
        }

        if (typeof prestacion.INICIO_VIG === "undefined" && typeof prestacion.INICIO_VIG_PREV !== "undefined" && prestacion.INICIO_VIG_PREV != null) {
          InicioVig = new Date(prestacion.INICIO_VIG_PREV);
          newInicioVig = `${InicioVig.getDate()}/${InicioVig.getMonth() + 1}/${InicioVig.getFullYear()} 00:00:00`;
        }

        const CodPertenenciaFonasa = prestacion.PERTENENCIA_FONASA || 0;

        //console.log("[PRESTACION UPDATE]:", prestacion);

        const prestacionDetalle = {
          CentroAtencionSecuencia: prestacion.SECUENCIA,
          CodigoFonasa: prestacion.CODIGO_FONASA,
          CodigoPrestacionIsapre: prestacion.COD_ISAPRE,
          CodigoPrestacionPrestador: prestacion.COD_PRESTADOR,
          CodigoProfesionalIsapre: prestacion.PROF_CCOD,
          CodigoProfesionalPrestador: prestacion.PROF_CCOD,
          FechaInicioVigenciaAnterior: newInicioVig,
          FechaInicioVigenciaPosterior: newInicioVig,
          FechaTerminoVigenciaAnterior: finVigencia,
          FechaTerminoVigenciaPosterior: finVigencia,
          GlosaGrupoPrestacionPrestador: prestacion.GLOSA_GRUPOPRESTADOR,
          GlosaPrestacionPrestador: prestacion.GLOSA_CODPRESTADOR,
          GrupoPrestacionIsapre: 0,
          GrupoPrestacionPrestador: 0,
          Guarismo: prestacion.GUARISMO,
          IdPrestacionIsapre: prestacion.IDPRESTACION,
          IdSolicitud: this.props.idSolicitud,
          IdDetallePrestacion: prestacion.IDDETALLEPRESTACION,
          IdTipoAccionPrestacion: prestacion.COD_OPERACION,
          PertenenciaFonasa: CodPertenenciaFonasa,
          Arancel: prestacion.RUTARANCEL,
          TipoAtencion: prestacion.TIPO_ATENCION,
          UnidadAnterior: prestacion.UNIDAD_ANT,
          UnidadPosterior: prestacion.UNIDAD,
          ValorAnterior: typeof prestacion.VALOR_ANT !== "undefined" ? prestacion.VALOR_ANT : null,
          ValorPosterior: prestacion.VALOR,
          Vigencia: prestacion.VIGENCIA ? prestacion.VIGENCIA : '1',
        };
        prestsToSend.push(prestacionDetalle);
      });

      this.props.dispatch(pushDetalleSolicitud({ prestsToSend, updateBorrador: true }));
    }
    this.props.dispatch(ErrorSnacktOpen("Borrador Guardado"));
  }


  EliminarBorradorSolicitud = () => {
    this.props.dispatch(deleteBorrador(this.props.idSolicitud, this.props.rutPrestador, this.props.rutInstitucion, this.props.isapre));
    this.props.dispatch(LimpiarSolicitud());
    this.props.dispatch(OpenModalEliminarBorrador(false));
  }


  OpenEditarPrestacionSolicitud(codOperacion, rowGuid) {
    const detallePrestacion = this.props.prestacionesSolicitud.filter((p) => p.GUID === rowGuid)[0];
    switch (codOperacion) {
      case 1:
      case "1":
        this.props.dispatch(OpenSolicitudEditarCreacion(true, detallePrestacion));
        break;
      case 2:
      case "2":
        this.props.dispatch(OpenSolicitudEditarEliminacion(true, detallePrestacion));
        break;
      case 3:
      case "3":
        this.props.dispatch(OpenSolicitudEditarModificacion(true, detallePrestacion));
        break;
      default:
        console.log(`OPERACION NO ENCONTRADA: ${codOperacion}`); break;
    }
  }

  SelIcon = (operacion, index) => {
    const boton = [];
    if (operacion.toString() === "1") {
      boton.push((
        <img
          alt="Tipo Doc"
          src={Add}
          className="img-fluid"
          height={25}
          width={45}
          key={`tablaRowGrillaSolicitudPrestaciones_imgadd_${index}`}
        />
      ));
    }
    if (operacion.toString() === "3") {
      boton.push((
        <img
          alt="Tipo Doc"
          src={Mod}
          className="img-fluid"
          height={25}
          width={45}
          key={`tablaRowGrillaSolicitudPrestaciones_imgmod_${index}`}
        />
      ));
    }
    if (operacion.toString() === "2") {
      boton.push((
        <img
          alt="Tipo Doc"
          src={Del}
          className="img-fluid"
          height={25}
          width={45}
          key={`tablaRowGrillaSolicitudPrestaciones_imgdel_${index}`}
        />
      ));
    }
    return boton;
  }

  render() {
    const { REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA: fechaVigenciaPrestador } = this.props.ENV;

    const menuListprestaciones = [];
    const dateMin = new Date(Date.now());
    dateMin.setDate(dateMin.getDate() + fechaVigenciaPrestador);
    dateMin.setHours(0, 0, 0, 0);

    //console.log('PRESTACIONES:', this.props.prestacionesSolicitud);

    this.props.prestacionesSolicitud.filter(p => typeof p.VIGENCIA == "undefined" || p.VIGENCIA != "0").forEach((row, index) => {
      let inicioVig = null;
      let finVigencia = null;
      let errorVigencia = false;

      if (!isNull(row.INICIO_VIG) && row.INICIO_VIG) {
        inicioVig = new Date(row.INICIO_VIG);
        inicioVig.setHours(0, 0, 0, 0);
        if (row.COD_OPERACION !== "2") {
          errorVigencia = inicioVig < dateMin;
        }
      }

      //console.log("[ROW]:", row);

      if (!isNull(row.FECHA_FIN_VIG)) {
        finVigencia = new Date(row.FECHA_FIN_VIG);
        finVigencia.setHours(0, 0, 0, 0);
        errorVigencia = finVigencia < dateMin;
      }


      menuListprestaciones.push((
        <TableRow
          style={errorVigencia ? { backgroundColor: red100 } : null}
          key={`tablaRowGrillaSolicitudPrestaciones_${index}`}
        >
          <TableRowColumn style={styles.comunStyleTable1}>{this.SelIcon(row.COD_OPERACION.toString(), index)}</TableRowColumn>
          <TableRowColumn style={styles.comunStyleTable2} title={row.COD_PRESTADOR}>{row.COD_PRESTADOR}</TableRowColumn>
          <TableRowColumn style={styles.comunStyleTable3} title={row.GLOSA_CODPRESTADOR == "NO ENCONTRADO" ? row.GLOSA_GRUPOPRESTADOR : row.GLOSA_CODPRESTADOR}>{row.GLOSA_CODPRESTADOR == "NO ENCONTRADO" ? row.GLOSA_GRUPOPRESTADOR : row.GLOSA_CODPRESTADOR}</TableRowColumn>
          <TableRowColumn style={styles.comunStyleTable4} title={row.COD_ISAPRE || row.CODIGO_FONASA}>{row.COD_ISAPRE || row.CODIGO_FONASA}</TableRowColumn>
          <TableRowColumn style={styles.comunStyleTable5} title={row.PROF_CCOD}>{row.PROF_CCOD}</TableRowColumn>
          <TableRowColumn style={styles.comunStyleTable6} title={row.VALOR}>{row.VALOR}</TableRowColumn>
          <TableRowColumn style={styles.comunStyleTable7} title={row.UNIDAD == 'VE' ? 'VF' : row.UNIDAD}>{row.UNIDAD == 'VE' ? 'VF' : row.UNIDAD}</TableRowColumn>
          <TableRowColumn style={styles.comunStyleTable8} title={row.TIPO_ATENCION}>{row.TIPO_ATENCION}</TableRowColumn>
          {inicioVig == null ?
            <TableRowColumn style={styles.comunStyleTable9}>---</TableRowColumn>
            :
            <TableRowColumn style={inicioVig < dateMin && row.COD_OPERACION !== "2" ? styles.comunStyleTable9Error : styles.comunStyleTable9}>
              {(new Date(row.INICIO_VIG)).toLocaleDateString()}
            </TableRowColumn>
          }
          {finVigencia == null ?
            <TableRowColumn style={styles.comunStyleTable9}>---</TableRowColumn>
            :
            <TableRowColumn style={finVigencia < dateMin ? styles.comunStyleTable9Error : styles.comunStyleTable9}>
              {(new Date(row.FECHA_FIN_VIG)).toLocaleDateString()}
            </TableRowColumn>
          }
          <TableRowColumn style={styles.comunStyleTable10}>{row.CENTRO_AT}</TableRowColumn>
          <TableRowColumn style={styles.comunStyleTable11}>{row.ARANCEL}</TableRowColumn>
          <TableRowColumn style={styles.comunStyleTable12}>{row.OPERACION}</TableRowColumn>
          <TableRowColumn style={styles.comunStyleTable13}>

            <IconButton
              key={`tablaRowGrillaSolicitudPrestaciones_btnedit_${index}`}
              iconStyle={styles.svgStyleResultado}
              style={styles.iconStyleResultado}

            >
              <Editar
                key={`tablaRowGrillaSolicitudPrestaciones_btnedit_img_${index}`}
                onClick={() => this.OpenEditarPrestacionSolicitud(row.COD_OPERACION, row.GUID)}
              />
            </IconButton>
            <IconButton
              key={`tablaRowGrillaSolicitudPrestaciones_btnedel_${index}`}
              iconStyle={styles.svgStyleResultado}
              style={styles.iconStyleResultado}
            >
              <Eliminar
                key={`tablaRowGrillaSolicitudPrestaciones_btnedel_img_${index}`}
                onClick={() => this.OpenQuitarPrestacionSolicitud(row.GUID)}

              />
            </IconButton>
          </TableRowColumn>
        </TableRow>
      ));
    });

    let numNuevas = 0;
    let numModificaciones = 0;
    let numEliminaciones = 0;
    if (this.props.prestacionesSolicitud) {
      numNuevas = this.props.prestacionesSolicitud.filter((p) => p.COD_OPERACION === "1").length;
      numEliminaciones = this.props.prestacionesSolicitud.filter((p) => p.COD_OPERACION === "2").length;
      numModificaciones = this.props.prestacionesSolicitud.filter((p) => p.COD_OPERACION === "3").length;
    }

    const actionsModalQuitar = [
      <FlatButton
        label="Cancelar"
        primary
        onClick={this.CloseQuitarPrestacionSolicitud}
      />,
      <FlatButton
        label="Aceptar"
        primary
        onClick={this.QuitarPrestacionSolicitudSeleccionada}
      />,
    ];

    const actionsModalEliminarBorrador = [
      <FlatButton
        label="Cancelar"
        primary
        onClick={this.CloseModalEliminarBorrador}
      />,
      <FlatButton
        label="Aceptar"
        primary
        onClick={this.EliminarBorradorSolicitud}
      />,
    ];

    /* if (this.props.idSolicitud != null && this.props.cargandoBorrador === false) {

    } */

    const actionsEnviarSolicitud = [
      <FlatButton
        label="Si, enviar"
        primary
        onClick={() => this.validarSolicitud(1)}
      />,
      <FlatButton
        label="No"
        primary
        onClick={this.mostrarModalEnviarSolicitud}
      />,
    ];

    return (
      <div>
        <div style={{ padding: "5px" }}>
          <Card
            initiallyExpanded
            zDepth={0}
          >
            <CardHeader
              actAsExpander
              showExpandableButton
              style={{
                paddingTop: "0px", paddingBottom: "0px", maxWidth: "990px",
              }}
            >
              <div style={styles.h1}>Prestaciones incluidas en la solicitud</div>
            </CardHeader>
            <CardText
              expandable
              style={{
                paddingTop: "0px", paddingBottom: "0px", maxWidth: "990px", overflow: "auto",
              }}
            >
              {(!this.props.prestacionesSolicitud || this.props.prestacionesSolicitud.length === 0) ?
                <span style={{ textAlign: "center" }}>No existen modificaciones en la solicitud</span>
                :
                <div>
                  <div style={{ overflowX: "auto" }}>
                    <div style={{ width: "2000px", overflow: "hidden" }}>
                      <Table
                        key="tablaGrillaSolicitudPrestaciones"
                        fixedHeader
                        selectable={false}
                        style={{ overflow: "hidden" }}
                      >
                        <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                          <TableRow selectable={false}>
                            <TableHeaderColumn style={styles.tituloTabla1}>Operacion</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTabla2}>Código<br />Prestación</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTabla3}>Glosa<br />Prestación</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTabla4}>Código<br />Isapre/Fonasa</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTabla5}>Código<br />Profesional</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTabla6}>Valor</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTabla7}>Unidad</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTabla8}>Tipo<br />Atención</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTabla9}>Fecha<br />Inicio Vigencia</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTabla9}>Fecha<br />Fin Vigencia</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTabla10}>Centro Atención</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTabla11}>Arancel</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTabla12}>Operación</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTabla13}>Editar/Eliminar</TableHeaderColumn>
                          </TableRow>
                        </TableHeader>
                        <TableBody
                          id="tablaBodyGrillaSolicitudPrestaciones"
                          deselectOnClickaway={false}
                          displayRowCheckbox={false}
                          stripedRows
                        >
                          {menuListprestaciones}
                        </TableBody>
                      </Table>
                    </div>
                  </div>
                  <TablePaginationCustom
                    key={`pag_tablaBodyGrillaSolicitudPrestaciones_${menuListprestaciones.length}`}
                    rowsPerPageDefault={5} // [5,10,15,20,25]
                    totalRows={menuListprestaciones.length}
                    pageDefault={1}
                    idTableBody="tablaBodyGrillaSolicitudPrestaciones"
                    showRowsPerPage={false}
                    labelStyleBtnPage={{ fontSize: "11px" }}
                    overlayStyleBtnPage={{ borderRadius: 20 }}
                    rippleStyleBtnPage={{ borderRadius: 20 }}
                    buttonStyleBtnPage={{ borderRadius: 20 }}
                    styleBtnPage={{
                      paddingLeft: 0,
                      paddingRight: 0,
                      paddingTop: 0,
                      paddingBottom: 0,
                      height: 25,
                      width: "45px",
                      minWidth: "45px",
                      borderRadius: 20,
                      marginRight: 5,
                    }}

                    labelStyleRowsPerPage={styles.h4}
                    underlineStyleRowsPerPage={styles.underlineSelectField}
                    iconStyleRowsPerPage={styles.iconSelectField}
                    menuItemStyleRowsPerPage={styles.menuItemStyleSelectField}
                    selectedMenuItemStyleRowsPerPage={styles.selectedMenuItemSelectField}
                    styleRowsPerPage={styles.selectFiledStyle}
                  />
                </div>
              }
            </CardText>
          </Card>
        </div>

        <div
          className="row"
          style={{
            paddingLeft: 10, marginLeft: 40, marginRight: 40, backgroundColor: "#e5e5e5",
          }}
        >
          <div className="col-xs-2" style={{ marginRight: 50 }} >
            <span style={styles.contadoresStyle}>Ingresos: {numNuevas} |</span>
          </div>
          <div className="col-xs-2" style={{ marginRight: 20 }} >
            <span style={styles.contadoresStyle}>Modificaciones: {numModificaciones} |</span>
          </div>
          <div className="col-xs-2" >
            <span style={styles.contadoresStyle}>Eliminaciones: {numEliminaciones}</span>
          </div>
        </div>

        <div
          className="row text-right"
          style={{
            textAlign: "right", paddingLeft: 0, marginLeft: 40, marginTop: 20, marginBottom: 20, width: 950,
          }}
        >
          <div style={{
            display: "none"
          }}
          >V1.11</div>
          <div className="col-xs-12" style={{ textAlign: "right", width: 950 }}>
            {this.props.ENV.DESHABILITAR_BORRADOR ?
              null
              :
              <RaisedButton
                label="Eliminar Borrador"
                onClick={() => this.validarSolicitud(2)}

                backgroundColor="#fff"
                labelPosition="before"
                overlayStyle={{ borderRadius: 5 }}
                labelStyle={{
                  fontSize: "11px", color: "#757575", paddingLeft: 10, paddingRight: 5, top: -3,
                }}
                style={{ width: "190px", borderRadius: 5 }}
                buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                icon={<Eliminar />}
                disabled={!this.props.prestacionesSolicitud || this.props.prestacionesSolicitud.length === 0}
              />
            }
            {this.props.ENV.DESHABILITAR_BORRADOR ?
              null
              :
              <RaisedButton
                onClick={() => this.validarSolicitud(3)}
                label="Guardar Borrador"
                backgroundColor="#fff"
                labelPosition="before"
                overlayStyle={{ borderRadius: 5 }}
                labelStyle={{
                  fontSize: "11px", color: "#00A100", paddingLeft: 10, paddingRight: 5, top: -3,
                }}
                style={{ width: "190px", borderRadius: 5, marginLeft: 20 }}
                buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                icon={<Getapp />}
                disabled={!this.props.prestacionesSolicitud || this.props.prestacionesSolicitud.length === 0}
              />
            }

            <RaisedButton
              label="Enviar Solicitud"
              secondary
              labelStyle={{ fontSize: "11px" }}
              onClick={this.mostrarModalEnviarSolicitud}
              overlayStyle={{ borderRadius: 5 }}
              rippleStyle={{ borderRadius: 5 }}
              style={{ width: "150px", borderRadius: 5, marginLeft: 20 }}
              buttonStyle={{ borderRadius: 5 }}
              disabled={!this.props.prestacionesSolicitud || this.props.prestacionesSolicitud.length === 0 || this.props.creando != null}
            />
            <Dialog
              actions={actionsEnviarSolicitud}
              modal
              open={this.state.modalEnviarSolicitud}
              style={{ width: "1000px", fontSize: "13px" }}
            >
              <div>
                ¿Confirma que desea enviar la solicitud?<br />
                <span style={{ color: "black" }}>(Si necesita enviarnos observaciones, por favor indíquelas a continuación)</span>
              </div>
              <TextField
                name="observaciones"
                id="observaciones"
                hintStyle={{ top: "3px", left: "3px", color: "rgba(0, 0, 0, 0.4)" }}
                underlineStyle={styles.underlineSelectField}
                inputStyle={styles.h4}
                value={this.state.observaciones}
                onChange={this.modificarObservaciones}
                style={styles.textFieldSolicitudObservacion}
                multiLine
                rows={4}
                rowsMax={4}
                maxLength={1000}
              />
            </Dialog>
          </div>
        </div>

        <div>
          <Drawer
            width="100%"
            openSecondary
            open={this.props.modalSolicitudEditarCreacion}
            docked={false}
          >
            {this.props.modalSolicitudEditarCreacion ?
              <SolicitudEditarCreacion />
              : null}
          </Drawer>
          <Drawer
            width="100%"
            openSecondary
            open={this.props.modalSolicitudEditarEliminacion}
            docked={false}
          >
            {this.props.modalSolicitudEditarEliminacion ?
              <SolicitudEditarEliminacion CambiosSinGuardar={this.props.CambiosSinGuardar} />
              : null}
          </Drawer>
          <Drawer
            width="100%"
            openSecondary
            open={this.props.modalSolicitudEditarModificacion}
            docked={false}
          >
            {this.props.modalSolicitudEditarModificacion ?
              <SolicitudEditarModificacion CambiosSinGuardar={this.props.CambiosSinGuardar} />
              : null}
          </Drawer>

          <Dialog
            key="modalQuitarPrestacionSolicitud"
            actions={actionsModalQuitar}
            modal
            open={this.props.modalQuitarPrestacionSolicitud}
            style={{ width: "700px", fontSize: "13px" }}
          >
            Se eliminará la fila seleccionada de la solicitud
          </Dialog>

          <Dialog
            key="modalEliminarBorradorSolicitud"
            actions={actionsModalEliminarBorrador}
            modal
            open={this.props.modalEliminarBorrador}
            style={{ width: "700px", fontSize: "13px" }}
          >
            Se eliminarán todas las prestaciones ({numNuevas + numEliminaciones + numModificaciones}) de la solicitud
          </Dialog>

          <Dialog
            key="modalGeneric"
            actions={[
              <FlatButton
                label="Aceptar"
                primary
                onClick={() => this.props.dispatch(DialogGeneric(false, null))}
              />,
            ]}
            modal
            open={this.props.dialogGeneric.open}
            title={
              <div>
                <div style={{ float: "right" }}>
                  <IconButton onClick={() => this.props.dispatch(DialogGeneric(false, null))} >
                    <i className="material-icons" style={{ color: "#ffffff" }}>close</i>
                  </IconButton>
                </div>
              </div>
            }
          >
            {this.props.dialogGeneric.contenido}
          </Dialog>

        </div>
        <Drawer
          width="100%"
          openSecondary
          open={this.props.modalSolicitudEnviada}
          docked={false}
        >
          {(this.props.modalSolicitudEnviada) ?
            <div style={{ width: "100%", fontSize: "13px" }}>
              <Card zDepth={0} style={{ padding: 0 }}>
                <CardText style={{ paddingBottom: 0 }}>
                  <div className="row" style={{ paddingBottom: 0 }}>
                    <div className="col-12">
                      <Paper zDepth={1} rounded={false} width="100%" style={{ margin: "10px 0px", width: "100%", padding: "10px 5px" }} >
                        <div className="col-12" style={{ margin: 0, padding: 0 }}>
                          <div style={styles.h1}>Solicitud de Actualización Arancel
                          </div>
                        </div>
                        <div className="col-5" style={{ margin: 0, padding: 0 }}>
                          <div className="row">
                            <div className="col-4" style={styles.tituloEnviarSolicitud}>
                              N°  solicitud
                            </div>
                            <div className="col-4" style={styles.datoEnviarSolicitud}>
                              {this.props.idSolicitud}
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-4" style={styles.tituloEnviarSolicitud}>
                              {(this.props.IdSolicitudHomologador == null) ? null : 'N°  solicitud Homologador'}
                            </div>
                            <div className="col-4" style={styles.datoEnviarSolicitud}>
                              {(this.props.IdSolicitudHomologador == 0) ? '...Creando Solicitud' : this.props.IdSolicitudHomologador}
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-4" style={styles.tituloEnviarSolicitud}>
                              Fecha Solicitud
                            </div>
                            <div className="col-4" style={styles.datoEnviarSolicitud}>
                              {(new Date()).toLocaleDateString()}
                            </div>
                          </div>
                        </div>
                        <div className="col-5" style={{ margin: 0, padding: 0 }}>
                          <div className="row">
                            <div className="col-4" style={styles.tituloEnviarSolicitud}>
                              Tipo Solicitud
                            </div>
                            <div className="col-4" style={styles.datoEnviarSolicitud}>
                              Actualizar Arancel
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-4" style={styles.tituloEnviarSolicitud}>
                              Estado Solicitud
                            </div>
                            <div className="col-4" style={styles.datoEnviarSolicitud}>
                              Solicitud Enviada
                            </div>
                          </div>
                        </div>
                        <div className="col-12" style={{ margin: 0, padding: 0 }}>
                          <div style={styles.h3}>
                            La resolución de su solicitud será notificada vía electrónica a su email
                            de contacto. De igual forma podrá revisar lo solicitado y el estado de
                            su solicitud en el menú
                            <RaisedButton
                              label="Solicitudes Realizadas"
                              onClick={this.ModalSolicitudReajuste}
                              secondary
                              labelStyle={{ fontSize: "11px" }}
                              overlayStyle={{ borderRadius: 5 }}
                              rippleStyle={{ borderRadius: 5 }}
                              style={{ width: "190px", borderRadius: 5, marginLeft: 20 }}
                              buttonStyle={{ borderRadius: 5 }}
                            />
                          </div>
                        </div>
                      </Paper>
                    </div>
                    {/*console.log("this.props.prestadorPuedeReplicar: ", this.props.prestadorPuedeReplicar)*/}
                    {/*console.log("this.props: ", this.props)*/}
                    {(this.props.prestadorPuedeReplicar && this.props.IdSolicitudHomologador != 0) ?
                      <div className="col-12">
                        <Paper zDepth={1} rounded={false} width="100%" style={{ margin: "10px 0px", width: "100%", padding: "10px 5px" }} >
                          <ReplicarSolicitud />
                        </Paper>
                      </div>
                      : null}
                  </div>
                </CardText>
              </Card>
            </div>
            : null}
        </Drawer>
      </div>
    );
  }
}

GrillaSolicitud.defaultProps = {
  rutInstitucion: null,
  rutPrestador: null,
  idSolicitud: null,
  cargandoBorrador: null,
};

GrillaSolicitud.propTypes = {
  IdSolicitudForHomologador: PropTypes.number,
  prestacionesToHomologador: PropTypes.array,
  prestacionesSolicitud: PropTypes.array.isRequired,
  modalSolicitudEditarCreacion: PropTypes.bool.isRequired,
  modalSolicitudEditarEliminacion: PropTypes.bool.isRequired,
  modalSolicitudEditarModificacion: PropTypes.bool.isRequired,
  modalQuitarPrestacionSolicitud: PropTypes.bool.isRequired,
  modalEliminarBorrador: PropTypes.bool.isRequired,
  rutInstitucion: PropTypes.number,
  rutPrestador: PropTypes.number,
  isapre: PropTypes.string.isRequired,
  idSolicitud: PropTypes.number,
  IdSolicitudHomologador: PropTypes.number,
  dispatch: PropTypes.func.isRequired,
  CambiosSinGuardar: PropTypes.func.isRequired,
  modalSolicitudEnviada: PropTypes.bool.isRequired,
  dialogGeneric: PropTypes.any.isRequired,
  ENV: PropTypes.any.isRequired,
  cargandoBorrador: PropTypes.bool,
  prestadorPuedeReplicar: PropTypes.bool.isRequired,
  datosUsuario: PropTypes.object.isRequired,
  creando: PropTypes.number,
};

const mapStateToProps = (state) => ({
  IdSolicitudForHomologador: state.grillaSolicitud.IdSolicitudForHomologador,
  prestacionesToHomologador: state.grillaSolicitud.prestacionesToHomologador,
  prestacionesSolicitud: state.grillaSolicitud.prestacionesSolicitud,
  modalSolicitudEditarCreacion: state.solicitudEditarCreacion.modalSolicitudEditarCreacion,
  modalSolicitudEditarEliminacion: state.solicitudEditarEliminacion.modalSolicitudEditarEliminacion,
  modalSolicitudEditarModificacion: state.solicitudEditarModificacion.modalSolicitudEditarModificacion,
  modalQuitarPrestacionSolicitud: state.grillaSolicitud.modalQuitarPrestacionSolicitud,
  modalEliminarBorrador: state.grillaSolicitud.modalEliminarBorrador,
  rutInstitucion: state.global.rutInstitucion,
  rutPrestador: state.global.rutPrestador,
  isapre: state.global.isapre,
  idSolicitud: state.grillaSolicitud.idSolicitud,
  IdSolicitudHomologador: state.grillaSolicitud.IdSolicitudHomologador,
  cargandoBorrador: state.grillaSolicitud.cargandoBorrador,
  modalSolicitudEnviada: state.grillaSolicitud.modalSolicitudEnviada,
  dialogGeneric: state.global.dialogGeneric,
  ENV: state.global.ENV,
  prestadorPuedeReplicar: state.replicarSolicitud.prestadorPuedeReplicar,
  datosUsuario: state.global.datosUsuario,
  creando: state.grillaSolicitud.creando,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(GrillaSolicitud);
